import React from "react";
import { PieChart, Pie, Cell } from 'recharts';

const COLORS = ["hsl(var(--chart-teal))", "hsl(var(--chart-grid))"];


export const UtilizationCharts = (props) => {
	const { data } = props;

    // const dataFound = data.utilization_cpu !== 0 && data.utilization_memory !== 0 && data.utilization_storage !== 0;
    const dataFound = true;

    const cpu = [
        {name: 'Used', value: data.utilization_cpu},
        {name: 'Free', value: 1 - data.utilization_cpu}
    ];

    const memory = [
        {name: 'Used', value: data.utilization_memory},
        {name: 'Free', value: 1 - data.utilization_memory}
    ];

    const storage = [
        {name: 'Used', value: data.utilization_storage},
        {name: 'Free', value: 1 - data.utilization_storage}
    ];

	return (
		<div className="">
            {dataFound ? (
                <div className="flex flex-row ml-6">
                    {data.has_storage_metrics && (
                        <>
                        <div className="mr-2 pt-1">Storage</div>
                        <PieChart width={30} height={30} className="mr-6">
                            <Pie
                                data={storage}
                                cx="50%"
                                cy="50%"
                                stroke=""
                                labelLine={false}
                                outerRadius={15}
                                fill="#8884d8"
                                dataKey="value"
                                isAnimationActive={false}
                                >
                                {storage.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                        </>
                    )}
                    {data.has_cpu_metrics && (
                        <>
                        <div className="mr-2 pt-1">CPU</div>
                        <PieChart width={30} height={30} className="mr-6">
                            <Pie
                                data={cpu}
                                cx="50%"
                                cy="50%"
                                stroke=""
                                labelLine={false}
                                outerRadius={15}
                                fill="#8884d8"
                                dataKey="value"
                                isAnimationActive={false}
                                >
                                {cpu.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                        </>
                    )}
                    {data.has_memory_metrics && (
                        <>
                        <div className="mr-2 pt-1">Memory</div>
                        <PieChart width={30} height={30} className="mr-6">
                            <Pie
                                data={memory}
                                cx="50%"
                                cy="50%"
                                stroke=""
                                labelLine={false}
                            outerRadius={15}
                            fill="#8884d8"
                            dataKey="value"
                            isAnimationActive={false}
                            >
                            {memory.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                            </Pie>
                        </PieChart>
                        </>
                    )}
                </div>
            ) : (
                <div></div>
            )}            
		</div>
	);
};
